import { useState } from "react"
import styles from "./cancel-registration-modal.module.css"

export default function CancelRegistrationModal({ registration, tournament, onClose, onConfirm }) {
    const [loading, setLoading] = useState(false)

    const handleConfirm = async () => {
        setLoading(true);
        await onConfirm(registration._id);
        onClose();
        setLoading(false);
    }

    function getStatusColor(status) {
        switch (status) {
            case "paid":
                return "#00d4ff"
            case "pending":
                return "#ffa500"
            case "cancelled":
                return "#ff6b6b"
            default:
                return "#808080"
        }
    }

    const formatDate = (dateString) => {
        return new Date(dateString).toLocaleDateString("en-US", {
            year: "numeric",
            month: "short",
            day: "numeric",
            hour: "2-digit",
            minute: "2-digit",
        })
    }


    return (
        <div className={styles.modalOverlay} onClick={onClose}>
            <div className={styles.modal} onClick={(e) => e.stopPropagation()}>
                <div className={styles.iconContainer}>
                    <span className={styles.warningIcon}>⚠</span>
                </div>

                <h2 className={styles.title}>Cancel Registration?</h2>

                <p className={styles.message}>
                    You are about to cancel the registration for <strong>{registration.gameId}</strong>. This action cannot
                    be undone.
                </p>

                <div className={styles.details}>
                    <p>
                        <strong>Game ID:</strong> {registration.gameId || "-"}
                    </p>
                    <p>
                        <strong>Registered At:</strong> {formatDate(registration.registeredAt)}
                    </p>
                    <p>
                        <strong>Current Status:</strong>{" "}
                        <span className={styles.statusBadge} style={{ backgroundColor: getStatusColor(registration.status) }}>
                            {registration.status}
                        </span>
                    </p>
                    {registration.teamName && (
                        <p>
                            <strong>Team:</strong> {registration.teamName || "-"}
                        </p>
                    )}
                    <p>
                        <strong>Registration Price:</strong> ₹{registration.registrationPrice}
                    </p>
                </div>

                <div className={styles.warningBox}>
                    <p className={styles.warning}>Important Notes:</p>
                    <ul className={styles.warningList}>
                        <li>The registration status will be changed to "cancelled"</li>
                        <li>The player will be notified about the cancellation</li>
                        {registration.status === "paid" && <li>Refund process may need to be initiated separately</li>}
                    </ul>
                </div>

                <div className={styles.formButtons}>
                    <button className={styles.cancelButton} onClick={onClose}>
                        Keep Registration
                    </button>
                    <button className={styles.confirmButton} onClick={handleConfirm}>
                        {loading ? "Cancelling..." : "Cancel Registration"}
                    </button>
                </div>
            </div>
        </div>
    )
}
